<template>
  <div class="opera-device">
    <!--字典项中文参数 设备信息 -->
    <topNav :title="$t('device_title')"
            url='/opera/setting'></topNav>
    <!--字典项中文参数 系统名称 -->
    <mt-cell :title="$t('device_name')"
             :value="os.name"></mt-cell>
    <!--字典项中文参数 系统语言 -->
    <mt-cell :title="$t('device_language')"
             :value="os.language"></mt-cell>
    <!--字典项中文参数 系统版本 -->
    <mt-cell :title="$t('device_version')"
             :value="os.version"></mt-cell>
    <!--字典项中文参数 系统供应商 -->
    <mt-cell :title="$t('device_vendor')"
             :value="os.vendor"></mt-cell>
    <div class="empty"></div>
    <!--字典项中文参数 设备型号 -->
    <mt-cell title="设备型号"
             :title="$t('device_model')"
             :value="device.model"></mt-cell>
    <!--字典项中文参数 生产厂商 -->
    <mt-cell :title="$t('device_vendor2')"
             :value="device.vendor"></mt-cell>
    <a class="mint-cell">
      <div class="mint-cell-left"></div>
      <div class="mint-cell-wrapper">
        <div class="mint-cell-title">
          <!--字典项中文参数 设备ID -->
          <span class="mint-cell-text">{{$t('device_uuid')}}</span>
        </div>
        <div class="mint-cell-value">
          <span style="font-size:12px">{{device.uuid}}</span>
        </div>
      </div>
      <div class="mint-cell-right"></div>
    </a>
    <div class="empty"></div>
    <!--字典项中文参数 网络类型 -->
    <mt-cell :title="$t('device_network')"
             :value="network"></mt-cell>
    <div class="empty"></div>
    <!--字典项中文参数 分辨率 -->
    <mt-cell :title="$t('device_screen')"
             :value="screen.resolutionWidth +'*' + screen.resolutionHeight"></mt-cell>
    <!--字典项中文参数 显示比例 -->
    <mt-cell title="显示比例"
             :title="$t('device_scale')"
             :value="screen.scale"></mt-cell>
    <mt-cell title="dpiX"
             :value="screen.dpiX"></mt-cell>
    <mt-cell title="dpiY"
             :value="screen.dpiY"></mt-cell>

  </div>
</template>
<script>
  export default {
    data() {
      return {
        os: {},
        device: {},
        screen: {},
        network: ""
      };
    },
    mounted() {
      this.os = plus.os;
      this.device = plus.device;
      this.screen = plus.screen;
      this.network = this.getNetWork();
    },
    methods: {
      getNetWork() {
        var n = plus.networkinfo.getCurrentType();
        if (n == plus.networkinfo.CONNECTION_UNKNOW) return "未知网络";
        else if (n == plus.networkinfo.CONNECTION_NONE) return "无网络";
        else if (n == plus.networkinfo.CONNECTION_ETHERNET) return "有线网络";
        else if (n == plus.networkinfo.CONNECTION_WIFI) return "WIFI";
        else if (n == plus.networkinfo.CONNECTION_CELL2G) return "2G";
        else if (n == plus.networkinfo.CONNECTION_CELL3G) return "3G";
        else if (n == plus.networkinfo.CONNECTION_CELL4G) return "4G";
        return "未知网络";
      }
    },
    components: {}
  };
</script>
<style lang='less' scoped>
  .opera-device {
    background-color: #f7f8fa;
    .empty {
      height: 0.6rem;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// device.vue?6bb3a0e3